// Auto-generated skeleton for Subscription

export const Subscription: Api.Subscription = {
  id: 0,
  name: '',
  description: '',
  link: '',
  subscriptionModules: null,
  subscriptionMethods: null,
};

